import { Control, FieldPath, FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "src/core/components/ui/form";
import { Textarea } from "src/core/components/ui/textarea";

type FormTextareaProps<T extends FieldValues> = {
  name: FieldPath<T>;
  label?: string | null;
  placeholder?: string;
  required?: boolean;
  className?: string;
  wrapperClassName?: string;
  control?: Control<T>;
};

export function FormTextarea<T extends FieldValues>({
  name,
  label = null,
  placeholder,
  required = false,
  className = "w-[400px] h-[80px]",
  control,
  wrapperClassName = "",
}: FormTextareaProps<T>) {
  const { t } = useTranslation();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem className={wrapperClassName}>
          {label && (
            <FormLabel required={required} className={`${fieldState.invalid ? "text-alert" : ""}`}>
              {label}
            </FormLabel>
          )}
          <FormControl>
            <Textarea
              className={`${className} ${fieldState.invalid ? "border-alert" : ""}`}
              placeholder={placeholder ? placeholder : t("global.form.input.placeholder")}
              {...field}
              value={field.value ?? ""}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
